
import { mapState } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  data() {
    return {
      story: {}
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log(to);
    console.log('Before route update');
    next();
  },
  async mounted() {
    // Determine the redirect URI based on the channel
    let redirectUri;

    if (window.location.href.includes('catering') || window.location.href.includes('2001')) {
      redirectUri = 'https://catering.bojangles.com/account/oauthcallback';
    } else {
      redirectUri = process.env.OLO_REDIRECT_URI;
    }

    // if (this.channel === 'catering') {
    //   // Pointing directly to prod to ensure it will work on live
    //   redirectUri = 'https://catering.bojangles.com/account/oauthcallback';
    // } else {
    //   redirectUri = process.env.OLO_REDIRECT_URI;
    // }

    console.log(redirectUri, 'redirectUri LOGIN.VUE');
    console.log(process.env.GW_ENV, 'process.env.GW_ENV LOGIN.VUE');

    // Redirect to SSO
    const redirect = await this.$axios({
      method: 'get',
      headers: {
        client_type: 'web',
        client_sub: this.channel === 'catering' ? 'catering' : null
      },
      url: '/api/v2/members/auth',
      params: {
        redirect_uri: redirectUri,
        code: true
      }
    }).then(res => {
      console.log("Sign In Response", res)
      return res.data.url + '&hide_header=true';
    }).catch(err => {
      return null;
    });

    if (redirect) {
      console.log("Redirect Response", redirect);
      window.location = redirect;
      return false;
    } else {
      this.$router.push('/');
      return false;
    }
  },
  async asyncData({ $storyblok }) {
    try {
      const story = await $storyblok.getStory('account/login');
      return { story };
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    ...mapState(['location', 'menu', 'order', 'channel']),
    state() {
      return process.env.APPLE_STATE;
    },
    clientId() {
      return process.env.APPLE_CLIENT_ID;
    }
  },
  methods: {
    onSignup() {
      const eventData = {
        event: 'start_sign_in',
        currency: 'USD'
      };

      if (this.order && this.order.products) {
        eventData.items = this.order.products;
        eventData.value = this.order.totals.total;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);

      this.$router.push('/account/signup');
    }
  }
}
